<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link to="/" class="black">{{ $t('building.properties') }}</router-link> /
            <span class="color-main">{{ $t('building.addNew') }}</span>
          </h6>
          <p class="font13 gray-col">{{ $t('building.subtitle') }}</p>
        </div>
      </div>
      <div class="white-box">
        <div class="main-title-box">{{ $t('building.addBuilding') }}</div>
        <div class="main-body-box">
          <div class="col-md-8 col-12">
            <v-form @submit.prevent="addBuilding" v-model="valid" ref="form">
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.nameAr') }}</h6>
                <v-text-field
                  type="text"
                  name="name[ar]"
                  :rules="defaultRoles"
                  :placeholder="$t('building.nameArPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.nameEn') }}</h6>
                <v-text-field
                  type="text"
                  name="name[en]"
                  :rules="defaultRoles"
                  :placeholder="$t('building.nameEnPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mb-4">
                <h6 class="mb-2 font14">{{ $t('building.buildingType') }}</h6>
                <Dropdown
                  v-model="selectedBuilding"
                  :options="buildingType"
                  filter
                  optionLabel="name"
                  :placeholder="$t('building.buildingTypePlaceholder')"
                  :emptyFilterMessage="$t('noData.noDataToShow')"
                  :emptyMessage="$t('noData.noDataToShow')"
                  class="main-select"
                />
              </div>
              <div class="main-input-cont mt-1" @click="showMap = true">
                <h6 class="mb-2 font14">{{ $t('building.buildingAddress') }}</h6>
                <v-text-field
                  type="text"
                  v-model="address"
                  :rules="defaultRoles"
                  :placeholder="$t('building.addressPlaceholder')"
                ></v-text-field>
                <div class="absLeft pointer-none">
                  <i class="fa-solid fa-map-pin"></i>
                </div>
              </div>
              <div class="main-input-cont mt-1 mb-4">
                <div class="flex-big-gap">
                  <div class="all-container-type">
                    <h6 class="mb-3">{{ $t('building.buildingUse') }}</h6>
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        checked
                        name="use"
                        value="living"
                        v-model="checkUseModal"
                        @change="checkUse"
                        id="company"
                        class="mainRadio"
                      />
                      <label for="company" class="font14">{{ $t('building.residential') }}</label>
                    </div>
                  </div>
                  <div class="all-container-type">
                    <h6 class="styleOnly mb-3">styleOnly</h6>
                    <div class="flex-sm-gap">
                      <input
                        type="radio"
                        id="user"
                        @change="checkUse"
                        v-model="checkUseModal"
                        value="commercial"
                        name="use"
                        class="mainRadio"
                      />
                      <label for="user" class="font14">{{ $t('building.commercial') }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.buildingCode') }}</h6>
                <v-text-field
                  type="text"
                  name="ref_code"
                  :rules="defaultRoles"
                  :placeholder="$t('building.buildingCodePlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.buildingAge') }}</h6>
                <v-text-field
                  type="number"
                  oninput="this.value = this.value.replace(/[^1-9.]/g, '').replace(/(\..*)\./g, '$1');"
                  name="age"
                  :rules="defaultRoles"
                  :placeholder="$t('building.buildingAgePlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.buildingArea') }}</h6>
                <v-text-field
                  type="number"
                       oninput="this.value = this.value.replace(/[^1-9.]/g, '').replace(/(\..*)\./g, '$1');"
                  name="area"
                  :rules="defaultRoles"
                  :placeholder="$t('building.buildingAreaPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.ownerRatio') }}</h6>
                <v-text-field
                  type="number"
                       oninput="this.value = this.value.replace(/[^1-9.]/g, '').replace(/(\..*)\./g, '$1');"
                  name="ratio"
                  :rules="defaultRoles"
                  :placeholder="$t('building.ownerRatioPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.apartmentsCount') }}</h6>
                <v-text-field
                  type="number"
                       oninput="this.value = this.value.replace(/[^1-9.]/g, '').replace(/(\..*)\./g, '$1');"
                  name="units_count"
                  :rules="defaultRoles"
                  :placeholder="$t('building.apartmentsCountPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1" v-if="showCommercial">
                <h6 class="mb-2 font14">{{ $t('building.shopsCount') }}</h6>
                <v-text-field
                  type="number"
                  name="shops_count"
                  :rules="defaultRoles"
                  :placeholder="$t('building.shopsCountPlaceholder')"
                ></v-text-field>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.descriptionAr') }}</h6>
                <v-textarea
                  :rules="defaultRoles"
                  name="description[ar]"
                  rows="7"
                  :placeholder="$t('building.descriptionArPlaceholder')"
                ></v-textarea>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14">{{ $t('building.descriptionEn') }}</h6>
                <v-textarea
                  :rules="defaultRoles"
                  name="description[en]"
                  rows="7"
                  :placeholder="$t('building.descriptionEnPlaceholder')"
                ></v-textarea>
              </div>
              <div class="main-input-cont">
                <div class="flex-big-gap no-align yes-wrap">
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('building.managementContract') }}</div>
                    <uploadFileSingle
                      name="contract"
                      id="uploadbuildingpaper"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('building.propertyDeed') }}</div>
                    <uploadFileSingle
                      name="instrument"
                      id="uploadbuildingpaper2"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('building.constructionCertificate') }}</div>
                    <uploadFileSingle
                      name="construction_completion_certificate"
                      id="uploadbuildingpaper3"
                    />
                  </div>
                  <div class="upload-all-div">
                    <div class="label-title mb-2">{{ $t('building.civilDefenseCertificate') }}</div>
                    <uploadFileSingle
                      name="civil_defense_certificate"
                      id="uploadbuildingpaper4"
                    />
                  </div>
                </div>
              </div>

              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl mt-4 mb-3"
              >
                <div v-if="!disabled">{{ $t('building.confirmAddBuilding') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('building.confirming') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
            </v-form>
          </div>
        </div>
      </div>
    </div>
  </main>

  <!-- Map modal  -->
  <Dialog v-model:visible="showMap" modal :style="{ width: '50vw' }">
    <h6 class="text-center py-3">{{ $t('building.addressOnMap') }}</h6>
    <div class="modal-body-main">
      <div id="map" style="min-height: 300px">
        <GoogleMap
          api-key="AIzaSyCGt8Jhn_NTdYJVqlyNfH5YQUXJyngCVok"
          :language="locale"
          :autocomplete="true"
          @change-address="getAddess"
        />
      </div>
    </div>
  </Dialog>

  <!-- success modal  -->
  <Dialog v-model:visible="showSuccess" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-3 mt-2">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font18 mb-4">
        {{ $t('building.buildingAddedSuccess') }}
      </h6>
      <div class="flex-group-me mb-2">
        <router-link :to="'/addTenant/' + buildingId" class="main-btn lg up">
          {{ $t('building.addTenants') }}
        </router-link>
        <router-link :to="'/buildingDetails/' + buildingId" class="main-btn lg up trans">
          {{ $t('building.buildingDetails') }}
        </router-link>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import uploadFileSingle from "../components/dashboard/uploadFileSingle.vue";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import GoogleMap from "vue-google-maps-ui";
import axios from "axios";
import { useI18n } from "vue-i18n";
const route = useRoute();
import { useRoute } from "vue-router";

import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
const { t } = useI18n();


// get locale 
import i18n from "@/i18n";
const locale = i18n.global.locale;

import { ref, onMounted } from "vue";

// reactive state
const defaultRoles = ref([
  (value) => {
    if (value) return true;

    return t('building.fieldRequired');
  },
]);
const successImg = ref(require("../assets/imgs/check.png"));
const showMap = ref(false);
const showSuccess = ref(false);
const showCommercial = ref(false);
const valid = ref(false);
const lat = ref(null);
const lng = ref(null);
const disabled = ref(false);
const form = ref(null);
const address = ref("");
const checkUseModal = ref("living");
const selectedBuilding = ref(null);
const buildingType = ref([]);

const buildingId = ref(null);

// functions
function addBuildingSend() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  if (route.params.id != 0) {
    fd.append("owner_id", route.params.id);
  }
  // fd.append("lat", 13.0);
  fd.append("lat", lat.value);
  if (selectedBuilding.value) {
    fd.append("building_type_id", selectedBuilding.value.id);
  }
  // fd.append("lng", 35.0);
  fd.append("lng", lng.value);
  fd.append("map_desc", address.value);
  // fd.append("map_desc", "test");

  axios
    .post("/manager/add-building", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        buildingId.value = response.data?.data?.id;
        showSuccess.value = true;
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        setTimeout(function () {
          router.push("/buildingsView");
        }, 1500);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function checkUse() {
  if (checkUseModal.value == "commercial") {
    showCommercial.value = true;
  } else {
    showCommercial.value = false;
  }
}
function getBuildingsTypes() {
  axios.get("/building-types").then((response) => {
    buildingType.value = response.data.data;
  });
}
function getAddess(e) {
  address.value = e.address;
  lat.value = e.info.geometry.location.lat();
  lng.value = e.info.geometry.location.lng();
}

// addBuilding
function addBuilding() {
  if (valid.value) {
    addBuildingSend();
  } else {
    scrollToDanger();
  }
}
// scroll to danger input
function scrollToDanger() {
  var element = document.querySelector(".v-input--error");
  if (element) {
    element.querySelector("input").focus();
  }
}

// lifecycle hooks
onMounted(() => {
  getBuildingsTypes();
});
</script>
